import * as actions from './actions'
import mutations from './mutations'
import * as getters from './getters'

const DeliveryStore = {
  state: {
    deliveries: [],
    countStatus: {},
    deliverySelected: {},
    saveTabSelected: '',
    partnerErrorCount: 0,
    driverDeliveryCounters: {}
  },
  getters,
  mutations,
  actions
}

export default DeliveryStore
